module.exports = __webpack_public_path__ + "img/2-chapter_1.420bd257.webp";